import { render, staticRenderFns } from "./UiDropdownDate.vue?vue&type=template&id=06b985a2&"
import script from "./UiDropdownDate.vue?vue&type=script&lang=js&"
export * from "./UiDropdownDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports